import * as React from "react"
const SvgCopy = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3 19.215q0 .825.587 1.412.588.587 1.413.587h10a.97.97 0 0 0 .713-.287.97.97 0 0 0 .287-.713.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.288H5v-10a.97.97 0 0 0-.287-.712A.97.97 0 0 0 4 8.214a.97.97 0 0 0-.712.288.97.97 0 0 0-.288.712v10Zm6-4.004V6.218l.002-.002.001-.002h8.994l.001.002.002.002v8.993l-.002.002-.001.001H9.003l-.001-.001zm-1.412 1.416q.587.587 1.412.587h9q.824 0 1.413-.587A1.93 1.93 0 0 0 20 15.214v-9q0-.824-.587-1.412A1.93 1.93 0 0 0 18 4.214H9q-.825 0-1.412.588A1.93 1.93 0 0 0 7 6.214v9q0 .825.588 1.413"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgCopy
